import {useRef, useState} from 'react';

import {FaAngleUp, FaPercent} from "react-icons/fa";
import Spinner from "../Spinner";

import {RiDeleteBinLine} from "react-icons/ri";

const AddDiscountCard = ({onConfirm,errorMessage,loading}) => {
    const inputRef = useRef(null);

    const handleFocus = () => {
        if (inputRef.current) {
            inputRef.current.scrollIntoView({
                behavior: "smooth", // Optional: for smooth scrolling
                block: "center",    // Scroll the input to the center of the view
            });
        }
    };
    const [isOpen, setIsOpen] = useState(false);
    const [code, setCode] = useState('');
    const [buttonIsDisable, setButtonIsDisable] = useState(true);
    const handleChangeDiscount = (e) => {

        if(e.target.value.length<=6){
            setButtonIsDisable(false);
            setCode(e.target.value);
        }else {
            setButtonIsDisable(false);
        }

    }
    const onBlur=()=>{
        window.scrollTo({
            top: 0,             // Scroll to the top of the page
            behavior: "smooth", // Optional: for smooth scrolling
        });

    }
    const toggleCard = () => {
        setIsOpen(!isOpen);
    };


    return (
        <div className="w-full mx-auto ">
            <div className="bg-white  rounded-lg  shadow-sm">
                <div
                    className="p-4 bg-white  rounded-lg cursor-pointer flex justify-between items-center"
                    onClick={toggleCard}
                >
                    <div className="flex justify-start items-center">
                        <div className="bg-green-100 p-2 ml-4 rounded-full">
                            <FaPercent className="text-sm text-green-600 "/>
                        </div>
                        <h2 className="text-sm ">کد تخفیف خود را وارد کنید.</h2>
                    </div>
                    <span>
                    <FaAngleUp className={`duration-300 transition transform ${isOpen ? "rotate-0" : "rotate-180"}`}/>


                    </span>
                </div>

                <div
                    className={`transition-all  duration-500 rounded-b-lg ease-in-out overflow-hidden bg-white ${
                        isOpen ? 'max-h-40' : 'max-h-0'
                    }`}
                >
                    <div className="  border-t px-4 py-5 flex   justify-center items-center ">
                        <input onBlur={onBlur} value={code} ref={inputRef} onFocus={handleFocus} onChange={handleChangeDiscount} placeholder="کد تخفیف را وارد کنید."
                               className="border-t border-b border-r outline-none focus:border focus:border-green-500  w-3/4  rounded-r  p-2 text-sm"/>
                        <button onClick={()=>onConfirm(code)} disabled={buttonIsDisable||loading}
                                className={` ${buttonIsDisable||loading ? 'opacity-60' : 'opacity-100'} duration-200 text-sm bg-green-500   font-semibold w-1/4   text-white   p-2 rounded-l-lg    `}>
                            {!loading ? "تایید کد": <div className="flex justify-center"><Spinner className="text-xl"/></div>}
                        </button>

                    </div>
                    {errorMessage && <p className="text-sm px-4    text-red-500  mb-2">{errorMessage}</p>}
                </div>
            </div>
        </div>
    );

};
const ActiveDiscountCard=({loading,onDelete,canDelete=false,code,error})=>{
    return <div
        className="bg-white  text-sm bg-white shadow-sm   w-full rounded-lg p-4">
        <div className="w-full  justify-between flex items-center">

                <span className="text-sm ">
                   کد تخفیف
                   <span className="text-green-500 mx-1 font-bold text-sm">
                      {code}#
                    </span>
                   برای شما اعمال شده است.
               </span>
            {canDelete &&!loading&&   <RiDeleteBinLine onClick={onDelete} className="text-red-500 text-xl" />}
            {loading && <Spinner className="text-green-500"/>}


        </div>

        {error && <p className="mt-1 text-red-500 text-sm ">{error}</p>}
    </div>
}

export default AddDiscountCard;
export {AddDiscountCard,ActiveDiscountCard}